export interface Category {
  slug: string;
  name: string;
  desc: string;
  banner: string;
}

export const categories: Category[] = [
  {
    slug: "lianai",
    name: "日漫恋爱",
    desc: "怦然心动的瞬间、青涩纯真的告白，恋爱题材日漫总能用细腻的笔触描绘出爱情最美好的样子。",
    banner:
      "https://readdy.ai/api/search-image?query=Japanese%20anime%20illustration%20of%20two%20teenagers%20under%20falling%20cherry%20blossoms%20on%20a%20school%20campus%20at%20sunset%2C%20soft%20warm%20golden%20light%2C%20romantic%20atmosphere%2C%20detailed%20cinematic%20background%2C%20high%20quality%20digital%20art&width=1600&height=500&seq=cat-lianai-banner&orientation=landscape",
  },
  {
    slug: "rexue",
    name: "日漫热血",
    desc: "燃烧的意志、不灭的斗志，热血题材以燃到极致的战斗与成长，一次次点燃观众的内心。",
    banner:
      "https://readdy.ai/api/search-image?query=Japanese%20anime%20illustration%20of%20a%20determined%20young%20warrior%20holding%20a%20sword%2C%20dynamic%20energy%20waves%20and%20fire%20around%2C%20epic%20battle%20atmosphere%2C%20dramatic%20lighting%2C%20cinematic%20composition%2C%20high%20quality%20digital%20art&width=1600&height=500&seq=cat-rexue-banner&orientation=landscape",
  },
  {
    slug: "xuanyi",
    name: "日漫悬疑",
    desc: "烧脑的谜题、反转再反转的剧情，悬疑题材让人一边屏息追番，一边感叹编剧的神奇脑洞。",
    banner:
      "https://readdy.ai/api/search-image?query=Japanese%20anime%20illustration%20of%20a%20mysterious%20detective%20in%20a%20dark%20noir%20city%20with%20fog%20and%20moonlight%2C%20intriguing%20shadows%2C%20tense%20atmosphere%2C%20cinematic%20mystery%20mood%2C%20high%20quality%20digital%20art&width=1600&height=500&seq=cat-xuanyi-banner&orientation=landscape",
  },
  {
    slug: "zhiyu",
    name: "日漫治愈",
    desc: "温柔的日常、静谧的陪伴，治愈题材用一个个平凡却动人的故事，轻轻抚平内心的疲惫。",
    banner:
      "https://readdy.ai/api/search-image?query=Japanese%20anime%20illustration%20of%20a%20peaceful%20countryside%20village%20in%20soft%20morning%20light%2C%20warm%20cozy%20atmosphere%2C%20gentle%20breeze%2C%20healing%20comforting%20mood%2C%20cinematic%20wide%20shot%2C%20high%20quality%20digital%20art&width=1600&height=500&seq=cat-zhiyu-banner&orientation=landscape",
  },
  {
    slug: "jizhan",
    name: "日漫机战",
    desc: "巨大机体的轰鸣、驾驶舱里的决意，机战题材将科幻设定与人性主题结合，燃与泪并存。",
    banner:
      "https://readdy.ai/api/search-image?query=Japanese%20anime%20illustration%20of%20a%20gigantic%20mecha%20robot%20standing%20on%20a%20battlefield%20under%20dramatic%20sky%2C%20mechanical%20details%2C%20epic%20sci-fi%20atmosphere%2C%20cinematic%20lighting%2C%20high%20quality%20digital%20art&width=1600&height=500&seq=cat-jizhan-banner&orientation=landscape",
  },
  {
    slug: "shenzuo",
    name: "日漫神作",
    desc: "跨越时间的经典、经久不衰的口碑，神作题材汇集那些值得反复品味的巅峰之作。",
    banner:
      "https://readdy.ai/api/search-image?query=Japanese%20anime%20illustration%20of%20a%20collection%20of%20iconic%20cinematic%20scenes%20blending%20into%20a%20dreamlike%20landscape%20at%20dusk%2C%20epic%20and%20nostalgic%20mood%2C%20cinematic%20lighting%2C%20high%20quality%20digital%20art&width=1600&height=500&seq=cat-shenzuo-banner&orientation=landscape",
  },
];